import config from './config';
import {combineReducers} from 'redux';
import {RELOAD_STATE} from "../constants/action-types";

const appReducer = combineReducers({
	config,
});

const rootReducer = (state, action) => {
	if (action.type === RELOAD_STATE) {
		state = {...state, ...action.payload};
	}
	return appReducer(state, action)
};

export default rootReducer;
